var DxServices;
(function (DxServices) {
    DxServices["ZILLOW"] = "zillow";
    DxServices["APARTMENTSDOTCOM"] = "apartmentsDotCom";
    DxServices["ENGRAIN"] = "engrain";
    DxServices["RENTCAFEV2"] = "rentCafeV2";
    DxServices["FUNNEL"] = "funnel";
    DxServices["ENTRATA"] = "entrata";
    DxServices["YARDI"] = "yardi";
    DxServices["REALPAGE"] = "realPage";
    DxServices["BOZZUTOMITS"] = "bozzutoMits";
    DxServices["ANYONEHOME"] = "anyoneHome";
    DxServices["KNOCK"] = "knock";
    DxServices["CORTLAND"] = "cortland";
    DxServices["ELISEAI"] = "eliseAi";
    DxServices["SEAM"] = "seam";
    DxServices["RESMAN"] = "resman";
})(DxServices || (DxServices = {}));
var DxSyncLabels;
(function (DxSyncLabels) {
    DxSyncLabels["PMS"] = "PMS";
    DxSyncLabels["CRM"] = "CRM";
    DxSyncLabels["ILS"] = "ILS";
})(DxSyncLabels || (DxSyncLabels = {}));
var DxSyncTypes;
(function (DxSyncTypes) {
    DxSyncTypes["PMS"] = "syncPms";
    DxSyncTypes["CRM"] = "syncProspect";
    DxSyncTypes["ILS"] = "syncIls";
    DxSyncTypes["SGT"] = "syncSgt";
    DxSyncTypes["Prospect"] = "syncProspectStatus";
    DxSyncTypes["AGT"] = "syncScheduleATour";
})(DxSyncTypes || (DxSyncTypes = {}));

export { DxServices, DxSyncLabels, DxSyncTypes };
